// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"90bfb18f","453":"66d20d22","732":"d40f4bfd","977":"ff79eaf0"}[chunkId] + ".chunk.js";
};